import { usePublicUserProfileQuery } from 'codegen/generated/user'
import { useUserIdQuery } from 'auth/hooks'

export function useIsSelfQuery({ userSlug }: { userSlug: string }) {
  const { data: loggedInUserId, isPending: isLoggedInPending } = useUserIdQuery()
  // temporary until we have this info in the user prop
  const { data: userData, isPending: isUserPending } = usePublicUserProfileQuery(
    { slug: userSlug },
    { select: data => data?.publicUserProfile },
  )

  // Check if the logged-in user ID matches the profile user ID
  const isSelf = loggedInUserId && userData?.id ? loggedInUserId === userData.id : undefined
  return { data: isSelf, isPending: isLoggedInPending || isUserPending }
}
